module.exports = __webpack_public_path__ + "media/assets/images/logo-black-20aabd65d0620d526c6659a2dae34494.png";